import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
//
import { NavListRoot } from './NavList';
import { useCallback, useLayoutEffect, useState } from 'react';
import axiosInstance from 'src/utils/axios';
import { useDispatch, useSelector } from 'react-redux';
import { getStatistic } from 'src/redux/slices/statistic';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const { statistics } = useSelector((state) => state.statistic);

  const { user } = useAuth()
  const role = user?.role
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(getStatistic())
  }, []);

  return (
    <Box {...other}>
      {navConfig.map((group) => {
        return (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {group.subheader}
            </ListSubheaderStyle>

            {group.items.map((list) => {
              if (list.role && !list.role.includes(role)) {
                return null
              }
              return (
                <NavListRoot role={role} key={list.title} list={list} isCollapse={isCollapse} statistic={statistics} />
              )
            })}
          </List>
        )
      })}
    </Box>
  );
}
